import { TGroupedStackType } from 'types/state';
import { M8StackType } from 'services/production/types';
import { UnreachableError } from 'utils/errors';

export const normalizeGroupedStackType = (stackType: TGroupedStackType) => ({
  toM8ClientStackType(): M8StackType {
    switch (stackType) {
      case 'DEMO':
        return 'DEMO';
      case 'MINI':
        return 'MINI';
      case 'STANDARD':
        return 'STANDARD';
      case 'VIP':
        return 'VIP';
      default:
        throw new UnreachableError(stackType);
    }
  },
});
